import React from 'react';

import { styleUtils } from '../../utils';

import { View } from '../View';

import styles from './styles';

const { style } = styleUtils;

const RootContainer = style(View, styles.rootContainer);

const Breadcrumb = () => <RootContainer>BREADCRUMB</RootContainer>;

export default Breadcrumb;
